import React from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import ButtonGroup from '../elements/ButtonGroup';
import Button from '../elements/Button';
// import Image from '../elements/Image';
//import Modal from '../elements/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faGooglePlay, faAppStoreIos } from '@fortawesome/free-brands-svg-icons'

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  // const [videoModalActive, setVideomodalactive] = useState(false);

  // const openModal = (e) => {
  //   e.preventDefault();
  //   setVideomodalactive(true);
  // }

  // const closeModal = (e) => {
  //   e.preventDefault();
  //   setVideomodalactive(false);
  // }   

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <h1 className="mt-0 mb-16 reveal-from-bottom" data-reveal-delay="0">
              Never Forget A <span className="text-color-primary">Moment</span>
            </h1>
            <div className="container-xs">
              <p className="m-0 mb-32 reveal-from-bottom" data-reveal-delay="0">
                Journaling, made simple. 
                </p>
              <div className="reveal-from-bottom" data-reveal-delay="0">
                <ButtonGroup>
                  <Button tag="a" color="primary" wideMobile href="https://play.google.com/store/apps/details?id=com.gigstudios.journal">
                    <FontAwesomeIcon icon={faGooglePlay} />
                    Google Play
                    </Button>
                  <Button tag="a" color="primary" wideMobile href="https://apps.apple.com/us/app/moments-journal-diary/id1626686699?platform=iphone">
                    <FontAwesomeIcon icon={faAppStoreIos} />
                    App Store
                    </Button>
                </ButtonGroup>
              </div>
            </div>
          </div>
          {/* <div className="hero-figure reveal-from-bottom illustration-element-01" data-reveal-value="0px" data-reveal-delay="800">
              <Image
                // className="has-shadow"
                src={require('./../../assets/images/s20mock.png')}
                alt="Hero"
                // width={300}
                height={20} 
                />
              </div> */}
        </div>
      </div>
    </section>
  );
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;